'use client';

import { useEffect, useRef } from 'react';
import { useSearchParams } from 'next/navigation';
import { usePathname } from '@/src/i18n/navigation';

export function useHotpadsComscorePageTracking(trackComscoreEvent: () => void) {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const search = searchParams?.toString() ?? '';
  const isInitialLoad = useRef(true);
  const trackComscoreEventRef = useRef(trackComscoreEvent);

  useEffect(() => {
    trackComscoreEventRef.current = trackComscoreEvent;
  }, [trackComscoreEvent]);

  useEffect(() => {
    if (isInitialLoad.current) {
      isInitialLoad.current = false;
      return;
    }

    trackComscoreEventRef.current();
  }, [pathname, search]);
}
